"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
let Metadata = class Metadata extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.selectFieldName = null;
        this.selectPlantDate = null;
        this.selectUuidClientField = null;
        this.selectVariety = null;
        this.selectDensity = null;
        this.selectBiodynamicMethods = null;
        this.selectArtIrrigation = this.typeFile === 'shp' ? null : false;
        this.selectIrrigationType = null;
        this.selectIrrigationUsage = null;
    }
    updateSelections() {
        this.$emit('updateSelections', {
            field_name: this.selectFieldName,
            plant_date: this.selectPlantDate,
            uuid_client_field: this.selectUuidClientField,
            variety: this.selectVariety,
            density: this.selectDensity,
            biodynamic_methods: this.selectBiodynamicMethods,
            artificial_irrigation: this.selectArtIrrigation,
            irrigation_type: this.selectIrrigationType,
            irrigation_usage: this.selectIrrigationUsage
        });
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], Metadata.prototype, "metadata", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'shp' })
], Metadata.prototype, "typeFile", void 0);
Metadata = __decorate([
    (0, vue_property_decorator_1.Options)({})
], Metadata);
exports.default = Metadata;
